import './app.scss';
import Landing from './components/landing/Landing.js';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Brandguidlanding from './components/BrandGuidline/Brandguidlanding.js';
import { Chatandpaylanding } from './components/Chatandpay/Chatandpaylanding.js';
import Buildgroup from './components/Browssecurley/Buildgroup.js';
import { Browssecurlylanding } from './components/Browsesecurlylanding/Browssecurlylanding.js';
import { Aboutuslanding } from './components/Aboutus/Aboutuslanding.js';
import { Createrprofile } from './components/createprofile/Createprofile.js';
import Whitepaperlanding from './components/whitepaper/Whitepaperlanding.js';
import Storagelanding from './components/Storage/Storagelanding.js';
import Roadmap from './components/Roadmap/Roadmap.js';
import Blog from './components/blog/Blog.js';
import Detailpage from './components/Detailpage/Detailpage.js';
import Homepage from './components/Homepage/Homepage.js';
import Contactus from './components/Contactus/Contactus.js';
import Termsofuse from './components/Termsofuse/Termsofuse.js';
import Privacypolicy from './components/Privacypolicy/Privacypolicy.js';
import LaunchModals from './components/LaunchModals/LaunchModals.js';
import Loader from './utils/loader.js';
import { useEffect, useState } from 'react';
import Support from './components/Support/Support.js';
import Walletlanding from './components/Wallet/Walletlanding.js';
import Errormain from './components/Erorpage/Errormain.js';
import Error301 from './components/Erorpage/Error301.js';
import redirects from './redirects.js';
import { useLocation } from 'react-router-dom';


function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const hasVisited = localStorage.getItem("hasVisited");
    if (hasVisited) {
      setLoading(false);
    } else {
      localStorage.setItem("hasVisited", "true");
      const timer = setTimeout(() => {
        setLoading(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, []);


  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const pathname = decodeURIComponent(location.pathname); 
    const search = location.search;

    if (
      pathname === "/blog/we-have-raises-$40m-to-build-a-decentralized,-surveillance-free-internet-alternative" &&
      search === "?id=1044"
    ) {
      navigate(
        "/blogdetail/we-have-raises-40m-to-build-a-decentralized-surveillance-free-internet-alternative/null",
        { replace: true }
      );
    }
  }, [location, navigate]);

  
  return (
    <>
      {
        loading && (<Loader />)
      }

  
        <Routes>
          <Route exact path='/' element={<Homepage />} />
          <Route exact path='/feature' element={<Landing />} />
          <Route exact path='/buildgroup' element={<Buildgroup />} />
          <Route exact path='/browsesecurely' element={<Browssecurlylanding />} />
          <Route exact path='/brandguidelines' element={<Brandguidlanding />} />
          <Route exact path='/chatandpay' element={<Chatandpaylanding />} />
          <Route exact path='/aboutus' element={<Aboutuslanding />} />
          <Route exact path='/createprofile' element={<Createrprofile />} />
          <Route exact path='/whitepaper' element={<Whitepaperlanding />} />
          <Route exact path='/storage' element={<Storagelanding />} />
          <Route exact path='/roadmap' element={<Roadmap />} />
          <Route exact path='/blog' element={<Blog />} />
          <Route exact path='/blogdetail/:id/:idTwo' element={<Detailpage />} />
          <Route exact path='/contactus' element={<Contactus />} />
          <Route exact path='/termofuse' element={<Termsofuse />} />
          <Route exact path='/privacypolicy' element={<Privacypolicy />} />
          <Route exact path='/support/:section' element={<Support />} />
          <Route exact path='/wallet' element={<Walletlanding />} />
          <Route exact path='*' element={<Errormain />} />

          <Route exact path='/301' element={<Errormain />} />

          {/* {redirects.map(({ from, to }) => (
            <Route key={from} path={from} element={<Error301 destination={to} />} />
          ))} */}

          {redirects.map(({ from, to }) => (
            <Route
              key={from}
              path={from.replace("https://tomi.com", "")} 
              element={<Navigate to={to.replace("https://www.tomi.com", "")} replace />}
            />
          ))}

        </Routes>
   
      <LaunchModals />
    </>
  );
}

export default App;


